import { LOADED, STATUS_NOT_LOADED } from "../../api/constant";

export const types = {
  CHANGE_INPUT_ENTRY_FORM: "change_input_entry_form",
  CHANGE_INPUT_ENTRY: "change_input_entry",
  CHANGE_INPUT_ENTRY_BY_OBJECT: "change_input_entry_by_object",
  CHANGE_INPUT_MODAL: "change_input_modal",
  CHANGE_PAYLOAD_ENTRY: "change_pyload_entry",
  CHANGE_STATUS_LOOK_FOR_CODE: "change_status_look_for_code",
  ITEMS_FOUND: "items_found",
  PROVIDERS_FOUND: "providers_found",
  OPEN_MODAL_ITEM: "open_modal_item",
  CLOSE_MODAL_ITEM: "close_modal_item",
  ADD_ITEM_MODAL: "add_item_modal",
  REMOVE_ITEM_TABLE: "remove_item_table",
  SET_PANEL_OBSERVATION: "set_panel_observation",
  TOGGLE_PANEL_OBSERVATION: "toggle_panel_observation",
  SET_ENTRY_ID: "set_entry_id",
  RELOAD_OBSERTATIONS: "reload_observation",
  RELOAD_DOCUMENTS: "reload_documents",
  CHANGE_INPUT_OBSERVATION: "change_input_observation",
  OBSERVATIONS_LOADED: "observation_loaded",
  DOCUMENTS_LOADED: "documents_loaded",
  REMOVE_PROVIDER: "remove_provider",
  CHANGE_PAYLOAD_MODAL_ITEM: "change_payload_modal_item",
  DELETE_ENTRY_DETAIL: "delete_entry_detail",
  CLEAN_ITEMS_FOUND: "clean_items_found",
  RELOAD_ENTRY_INITIAL_STATE: "reload_entry_initial_state"
};
export const INITIAL_STATE = {
  loading: false,
  lookForCode: "",
  lookForProvider: "",
  lookForProviderStatus: STATUS_NOT_LOADED,
  lookForStatus: STATUS_NOT_LOADED,
  lookedItems: [],
  lookedProviders: [],
  entry: {
    status: STATUS_NOT_LOADED,
    id: null,
    provider_id: null,
    provider_name: "",
    quantity_references: 0,
    date_movement: new Date(),
    created_at: null,
    order_number: "",
    business_client_id: null,
    business_name: "",
    business_nit: "",
    status_id: null,
    warehouse_id: null,
    type: "",
    items: [],
    observation: {
      text: "",
      status: LOADED,
      observations: [],
    },
    document: {
      status: LOADED,
      documents: [],
    },
  },
  modalItem: {
    code: "",
    item_id: null,
    name: "",
    measure_name: "",
    abreviature: "",
    lote: "",
    has_lote: false,
    has_date_made: false,
    has_date_expired: false,
    brand: null,
    date_expired: null,
    date_made: null,
    quantity: 0,
    brands: [],
    items: [],
  },
  panelObservation: {
    up: false,
    watchDocuments: false,
  },
  error: false,
};

export const entryReducer = (state, action) => {
  const payload = action.payload;

  const {
    CHANGE_INPUT_ENTRY_FORM,
    CHANGE_STATUS_LOOK_FOR_CODE,
    ITEMS_FOUND,
    CHANGE_INPUT_ENTRY,
    CHANGE_INPUT_ENTRY_BY_OBJECT,
    CHANGE_PAYLOAD_ENTRY,
    OPEN_MODAL_ITEM,
    CLOSE_MODAL_ITEM,
    CHANGE_INPUT_MODAL,
    ADD_ITEM_MODAL,
    REMOVE_ITEM_TABLE,
    SET_PANEL_OBSERVATION,
    TOGGLE_PANEL_OBSERVATION,
    SET_ENTRY_ID,
    RELOAD_OBSERTATIONS,
    CHANGE_INPUT_OBSERVATION,
    OBSERVATIONS_LOADED,
    DOCUMENTS_LOADED,
    RELOAD_DOCUMENTS,
    PROVIDERS_FOUND,
    REMOVE_PROVIDER,
    CHANGE_PAYLOAD_MODAL_ITEM,
    DELETE_ENTRY_DETAIL,
    CLEAN_ITEMS_FOUND,
    RELOAD_ENTRY_INITIAL_STATE,
  } = types;
  switch (action.type) {
    case CHANGE_INPUT_ENTRY_FORM:
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
    case CHANGE_INPUT_ENTRY:
      return {
        ...state,
        entry: { ...state.entry, [action.payload.name]: action.payload.value },
      };
    case CHANGE_PAYLOAD_ENTRY:
      return {
        ...state,
        entry: payload,
      };
    case CHANGE_PAYLOAD_MODAL_ITEM:
      return {
        ...state,
        modalItem: payload,
      };
    case CHANGE_INPUT_MODAL:
      return {
        ...state,
        modalItem: {
          ...state.modalItem,
          [payload.name]: payload.value,
        },
      };
    case CHANGE_INPUT_ENTRY_BY_OBJECT:
      return {
        ...state,
        entry: { ...state.entry, id: payload.id, status: payload.status },
      };
    case CHANGE_STATUS_LOOK_FOR_CODE:
      return {
        ...state,
        lookForStatus: action.payload,
      };
    case ADD_ITEM_MODAL:
      return {
        ...state,
        modalItem: {
          ...state.modalItem,
          lote: "",
          date_expired: null,
          date_made: null,
          quantity: 0,
          brand:null,
          items: [
            ...state.modalItem.items,
            {
              lote: state.modalItem.lote,
              date_expired: state.modalItem.date_expired,
              date_made: state.modalItem.date_made,
              quantity: state.modalItem.quantity,
              brand: state.modalItem.brand,
            },
          ],

        },
      };
    case REMOVE_ITEM_TABLE:
      return {
        ...state,
        modalItem: {
          ...state.modalItem,
          items: state.modalItem.items.filter((item, i) => i !== payload.index),
        },
      };
    case OPEN_MODAL_ITEM:
      return {
        ...state,
        modalItem: {
          ...state.modalItem,
          item_id: payload.item_id,
          name: payload.name,
          measure_name: payload.measure_name,
          has_date_expired: payload.has_date_expired,
          abreviature: payload.abreviature,
          code: payload.code,
          has_lote: payload.has_lote,
          has_date_made: payload.has_date_made,
        },
      };
    case CLOSE_MODAL_ITEM:
      return {
        ...state,
        modalItem: {
          ...state.modalItem,
          item_id: null,
          name: "",
          abreviature: "",
        },
      };
    case PROVIDERS_FOUND:
      return {
        ...state,
        lookForProviderStatus: LOADED,
        lookedProviders: action.payload,
      };
    case ITEMS_FOUND:
      return { ...state, lookForStatus: LOADED, lookedItems: action.payload };
    case CLEAN_ITEMS_FOUND:
      return { ...state, lookedItems: [], lookForCode: "" };
    case SET_PANEL_OBSERVATION:
      return {
        ...state,
        panelObservation: {
          ...state.panelObservation,
          watchDocuments: action.payload,
        },
      };
    case TOGGLE_PANEL_OBSERVATION:
      return {
        ...state,
        panelObservation: {
          ...state.panelObservation,
          up: !state.panelObservation.up,
        },
      };
    case SET_ENTRY_ID:
      return {
        ...state,
        entry: {
          ...state.entry,
          id: action.payload,
        },
      };
    case RELOAD_OBSERTATIONS:
      return {
        ...state,
        entry: {
          ...state.entry,
          observation: {
            ...state.entry.observation,
            status: STATUS_NOT_LOADED,
          },
        },
      };
    case RELOAD_DOCUMENTS:
      return {
        ...state,
        entry: {
          ...state.entry,
          document: {
            ...state.entry.document,
            status: STATUS_NOT_LOADED,
          },
        },
      };
    case CHANGE_INPUT_OBSERVATION:
      return {
        ...state,
        entry: {
          ...state.entry,
          observation: {
            ...state.entry.observation,
            [payload.name]: payload.value,
          },
        },
      };
    case OBSERVATIONS_LOADED:
      return {
        ...state,
        entry: {
          ...state.entry,
          observation: {
            ...state.entry.observation,
            observations: payload,
            status: LOADED,
          },
        },
      };
    case DOCUMENTS_LOADED:
      return {
        ...state,
        entry: {
          ...state.entry,
          document: {
            ...state.entry.document,
            documents: payload,
            status: LOADED,
          },
        },
      };
    case REMOVE_PROVIDER:
      return {
        ...state,
        lookForProvider: "",
        lookedProviders: [],
        entry: {
          ...state.entry,
          business_client_id: null,
          business_name: "",
          business_nit: "",
        },
      };
    case DELETE_ENTRY_DETAIL:
      return {
        ...state,
        entry: {
          ...state.entry,
          items: state.entry.items.filter((i) => i.id !== payload),
        },
      };
    case RELOAD_ENTRY_INITIAL_STATE:
        return INITIAL_STATE;
    default:
      return state;
  }
};
